import request from '@/tools/request'

export const state = () => ({
  tasks: [],
  risks: [],
  controls: [],
})

export const mutations = {
  addHazardRegister(state, hazardDataObj) {
    state.tasks = hazardDataObj.tasks
    state.risks = hazardDataObj.risks
    state.controls = hazardDataObj.controls
  },
}

export const getters = {
  getRisk: (state) => (riskid) => {
    return state.risks.filter((x) => x.id === riskid)
  },
  getRisksFromTaskId: (state) => (taskid) => {
    return state.risks.filter((x) => x.taskid === taskid)
  },
  getControlsFromRiskId: (state) => (riskid) => {
    return state.controls.filter((x) => x.riskid === riskid)
  },
  getTask: (state) => (id) => {
    return state.tasks.filter((x) => x.id === id)
  },
}

export const actions = {
  getRegister({ commit }) {
    return request.getRequest('/hazards/add/register').then((res) => {
      commit('addHazardRegister', res.data)
    })
  },
}
